module.exports = __webpack_public_path__ + "static/img/madani.cab0bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/madani.png
// module id = bEoU
// module chunks = 107